export default {
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  methods: {
    /**
     * Set windowWith variable
     */
    resizeHandler() {
      this.windowWidth = window.innerWidth;
    }
  },
  created() {
    // Init window with variable
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  }
};
